module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page page-profile"
  }, [_vm._m(0), _vm._v(" "), (!_vm.Helpers.isTouch()) ? _c('ul', {
    staticClass: "weeks-list"
  }, _vm._l((_vm.weeks), function(item) {
    return _c('li', {
      staticClass: "weeks-item",
      class: {
        active: item.id <= _vm.currentWeek, current: item.id === _vm.currentWeek
      }
    }, [_c('div', {
      staticClass: "item-content"
    }, [((item.id <= _vm.currentWeek) && (_vm.getWeekData(item.id))) ? _c('div', {
      staticClass: "item-wrapper"
    }, [_c('div', {
      staticClass: "week-group"
    }, [_c('div', {
      staticClass: "cup-icon"
    }, [_c('svg-cup')], 1), _vm._v(" "), _c('h3', {
      staticClass: "text"
    }, [_vm._v(_vm._s(item.name))])]), _vm._v(" "), _c('div', {
      staticClass: "line"
    }), _vm._v(" "), _c('div', {
      staticClass: "item-info"
    }, [_c('div', {
      staticClass: "item-info__place"
    }, [_vm._v(_vm._s(_vm.getWeekData(item.id).position) + " место")]), _vm._v(" "), _c('div', {
      staticClass: "item-info__bottom-group"
    }, [_c('div', {
      staticClass: "item-info__time-group"
    }, [_vm._v("\n\t\t\t\t\t\t\t\t" + _vm._s(_vm.toHHMMSS(_vm.getWeekData(item.id).time)) + "\n\t\t\t\t\t\t\t\t"), _c('div', {
      staticClass: "item-info__time-group-icon"
    }, [_c('svg-clock')], 1)]), _vm._v(" "), _c('div', {
      staticClass: "item-info__divider"
    }), _vm._v(" "), _c('div', {
      staticClass: "item-info__favorites-group"
    }, [_vm._v("\n\t\t\t\t\t\t\t\t" + _vm._s(_vm.getWeekData(item.id).score) + "\n\t\t\t\t\t\t\t\t"), _c('div', {
      staticClass: "item-info__favorites-group-icon"
    }, [_c('svg-star')], 1)])]), _vm._v(" "), (_vm.getWeekData(item.id).link) ? _c('div', {
      staticClass: "item-info__video-replay"
    }, [_c('a', {
      attrs: {
        "target": "_blank",
        "href": _vm.getWeekData(item.id).link
      }
    }, [_vm._v("+ видеоповтор")])]) : _vm._e()])]) : _c('div', {
      staticClass: "item-wrapper"
    }, [_c('div', {
      staticClass: "week-group"
    }, [_c('h3', {
      staticClass: "text"
    }, [_vm._v(_vm._s(item.name))])]), _vm._v(" "), _c('div', {
      staticClass: "line"
    })])])])
  })) : _c('swiper', {
    staticClass: "weeks-list slider",
    attrs: {
      "options": this.swiperOptions
    }
  }, [_c('div', {
    staticClass: "swiper-button-prev",
    attrs: {
      "slot": "button-prev"
    },
    slot: "button-prev"
  }, [_c('arrow')], 1), _vm._v(" "), _c('div', {
    staticClass: "swiper-button-next",
    attrs: {
      "slot": "button-next"
    },
    slot: "button-next"
  }, [_c('arrow')], 1), _vm._v(" "), _vm._l((_vm.weeks), function(item) {
    return _c('swiper-slide', {
      key: item.id,
      staticClass: "weeks-item",
      class: {
        active: item.id <= _vm.currentWeek, current: item.id === _vm.currentWeek
      }
    }, [_c('div', {
      staticClass: "item-content-wrapper"
    }, [_c('div', {
      staticClass: "item-content"
    }, [((item.id <= _vm.currentWeek) && (_vm.getWeekData(item.id))) ? _c('div', {
      staticClass: "item-wrapper"
    }, [_c('div', {
      staticClass: "week-group"
    }, [_c('div', {
      staticClass: "cup-icon"
    }, [_c('svg-cup')], 1), _vm._v(" "), _c('h3', {
      staticClass: "text"
    }, [_vm._v(_vm._s(item.name))])]), _vm._v(" "), _c('div', {
      staticClass: "line"
    }), _vm._v(" "), _c('div', {
      staticClass: "item-info"
    }, [_c('div', {
      staticClass: "item-info__place"
    }, [_vm._v(_vm._s(_vm.getWeekData(item.id).position) + " место")]), _vm._v(" "), _c('div', {
      staticClass: "item-info__bottom-group"
    }, [_c('div', {
      staticClass: "item-info__time-group"
    }, [_vm._v("\n\t\t\t\t\t\t\t\t\t" + _vm._s(_vm.toHHMMSS(_vm.getWeekData(item.id).time)) + "\n\t\t\t\t\t\t\t\t\t"), _c('div', {
      staticClass: "item-info__time-group-icon"
    }, [_c('svg-clock')], 1)]), _vm._v(" "), _c('div', {
      staticClass: "item-info__divider"
    }), _vm._v(" "), _c('div', {
      staticClass: "item-info__favorites-group"
    }, [_vm._v("\n\t\t\t\t\t\t\t\t\t" + _vm._s(_vm.getWeekData(item.id).score) + "\n\t\t\t\t\t\t\t\t\t"), _c('div', {
      staticClass: "item-info__favorites-group-icon"
    }, [_c('svg-star')], 1)])]), _vm._v(" "), (_vm.getWeekData(item.id).link) ? _c('div', {
      staticClass: "item-info__video-replay"
    }, [_c('a', {
      attrs: {
        "target": "_blank",
        "href": _vm.getWeekData(item.id).link
      }
    }, [_vm._v("+ видеоповтор")])]) : _vm._e()])]) : _c('div', {
      staticClass: "item-wrapper"
    }, [_c('div', {
      staticClass: "week-group"
    }, [_c('h3', {
      staticClass: "text"
    }, [_vm._v(_vm._s(item.name))])]), _vm._v(" "), _c('div', {
      staticClass: "line"
    })])])])])
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "page-content"
  }, [_c('div', {
    staticClass: "user-block"
  }, [_c('div', {
    staticClass: "title-wrapper"
  }, [_c('div', {
    staticClass: "user-avatar",
    style: (("background-image: url(" + (_vm.user.image_link ? _vm.user.image_link : _vm.noAvatar) + ")"))
  }), _vm._v(" "), _c('h1', {
    staticClass: "title user-name"
  }, [_vm._v(_vm._s(_vm.user.first_name) + " " + _vm._s(_vm.user.last_name))])]), _vm._v(" "), _c('div', {
    staticClass: "text-wrapper"
  }, [(!_vm.userRating.length) ? _c('p', {
    staticClass: "text"
  }, [_vm._v("\n\t\t\t\t\tПройди тест и загрузи "), _c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.getVideoPopup($event)
      }
    }
  }, [_vm._v("видеоповтор")]), _vm._v(", чтобы попасть в общий рейтинг\n\t\t\t\t\t"), _c('router-link', {
    attrs: {
      "to": "/test/start"
    }
  }, [_vm._v("пройди тест")])], 1) : _c('p', {
    staticClass: "text"
  }, [_vm._v("\n\t\t\t\t\tСпасибо! Результат сохранен, можно улучшить свою позицию в рейтинге, загрузив "), _c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.getVideoPopup($event)
      }
    }
  }, [_vm._v("видеоповтор")]), _vm._v(".\n\t\t\t\t")])])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "lines-wrapper"
  }, [_c('div', {
    staticClass: "lines-circle"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a8e529d0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/Profile.vue
// module id = 511
// module chunks = 1